export default "__VITE_ASSET__2364ac63__"